import React from 'react'
import KyrgyzstanFlag from 'components/ContentBox/img/kyrgyzstan.svg'
import RussiaFlag from 'components/ContentBox/img/russia.svg'
import UkraineFlag from 'components/ContentBox/img/ukraine.svg'
import BelarusFlag from 'components/ContentBox/img/belarus.svg'
import UzbekistanFlag from 'components/ContentBox/img/uzbekistan.svg'
import KazakhstanFlag from 'components/ContentBox/img/kazakhstan.svg'
import UAEFlag from 'components/ContentBox/img/uae.svg'
import GermanyFlag from 'components/ContentBox/img/germany.svg'
import UKFlag from 'components/ContentBox/img/uk.svg'
import VenezuelaFlag from 'components/ContentBox/img/venez.svg'
import SingaporeFlag from 'components/ContentBox/img/SingaporeFlag.svg'
import USAFlag from 'components/ContentBox/img/usa.svg'
import TurkeyFlag from 'components/ContentBox/img/turkey.svg'

export const countries = [
  {
    type: '+7',
    maxLength: 15,
    minLength: 15,
    validLength: 11,
    icon: () => <img src={KazakhstanFlag} alt='flag/icon' />,
    title: 'Kazakhstan',
  },
  {
    type: '+7',
    maxLength: 15,
    minLength: 15,
    validLength: 11,
    icon: () => <img src={RussiaFlag} alt='flag/icon' />,
    title: 'Russia',
  },
  {
    type: '+375',
    maxLength: 14,
    minLength: 14,
    validLength: 12,
    icon: () => <img src={BelarusFlag} alt='flag/icon' />,
    title: 'Belarus',
  },
  {
    type: '+380',
    maxLength: 14,
    minLength: 14,
    validLength: 12,
    icon: () => <img src={UkraineFlag} alt='flag/icon' />,
    title: 'Ukraine',
  },
  {
    type: '+996',
    maxLength: 13,
    minLength: 13,
    validLength: 12,
    icon: () => <img src={KyrgyzstanFlag} alt='flag/icon' />,
    title: 'Kyrgyzstan',
  },
  {
    type: '+998',
    maxLength: 11,
    minLength: 11,
    validLength: 12,
    icon: () => <img src={UzbekistanFlag} alt='flag/icon' />,
    title: 'Uzbekistan',
  },
  {
    type: '+971',
    maxLength: 15,
    minLength: 15,
    validLength: 12,
    icon: () => <img src={UAEFlag} alt='flag/icon' />,
    title: 'UAE',
  },
  {
    type: '+49',
    maxLength: 13,
    minLength: 12,
    validLength: 10,
    icon: () => <img src={GermanyFlag} alt='flag/icon' />,
    title: 'Germany',
  },
  {
    type: '+44',
    maxLength: 12,
    minLength: 12,
    validLength: 10,
    icon: () => <img src={UKFlag} alt='flag/icon' />,
    title: 'United Kingdom',
  },
  {
    type: '+58',
    maxLength: 12,
    minLength: 12,
    validLength: 10,
    icon: () => <img src={VenezuelaFlag} alt='flag/icon' />,
    title: 'Venezuela',
  },
  {
    type: '+65',
    maxLength: 12,
    minLength: 12,
    validLength: 10,
    icon: () => <img src={SingaporeFlag} alt='flag/icon' />,
    title: 'Singapore',
  },
  {
    type: '+1',
    maxLength: 11,
    minLength: 11,
    validLength: 10,
    icon: () => <img src={USAFlag} alt='flag/icon' />,
    title: 'United States',
  },
  {
    type: '+90',
    maxLength: 12,
    minLength: 12,
    validLength: 10,
    icon: () => <img src={TurkeyFlag} alt='flag/icon' />,
    title: 'Turkey',
  },
]
